import { gql } from '@apollo/client';

export const CREATE_USER = gql`
  mutation CreateUser($user: UserInput!, $fromHigoPay: Boolean) {
    createUser(user: $user, fromHigoPay: $fromHigoPay) {
      token
    }
  }
`;
